"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/layout/style/index.js
// module id = 108
// module chunks = 1